import { render } from "./CaptchaBlock.vue?vue&type=template&id=54ed6ca8"
import script from "./CaptchaBlock.vue?vue&type=script&lang=js"
export * from "./CaptchaBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__